import Requests from "@/services/Requests";

const state = {
  projects: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allProjects: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  projectById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  changedLogs: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  projectPermissions: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of projects based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter projects by. Defaults to 0.
   * @return {Array} An array of projects filtered by the given page number. If page is 0, returns all projects.
   */
  getProjects:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.projects.data
        : state.projects.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllProjects: (state) => state.allProjects.data,
  getProjectStatus: (state) => state.projects.status,
  getProjectCount: (state) => state.projects.count,
  getProjectPage: (state) => state.projects.page,
  getProjectPages: (state) => (limit) => Math.ceil(state.projects.count / limit),
  getProjectsLoading: (state) => state.projects.status === "loading",
  getProjectById: (state) => (id) =>
    state.projectById.data.find((d) => d.id === id) || {},
  getProjectChangedLogsById: (state) => (id) =>
    state.changedLogs.data.find((d) => d.projectId === id) || { items: [] },
  getProjectChangedLogsLoadingById: (state) =>
    state.changedLogs.status === "loading",
  getProjectPermissionsById: (state) => (id) =>
    state.projectPermissions.data.find((d) => d.projectId === id) || {
      items: [],
    },
  getProjectPermissionsLoadingById: (state) =>
    state.projectPermissions.status === "loading",
};
const mutations = {
  /**
   * Updates the status of the project in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the project.
   */
  SET_PROJECT_STATUS(state, payload) {
    state.projects.status = payload;
  },
  /**
   * Sets the projects and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of projects.
   * @param {number} payload.count - The total count of projects.
   */
  SET_PROJECTS(state, payload) {
    state.projects.data = payload.items;
    state.projects.count = payload.count;
    console.log(state.projects.data, "state.projects.data", payload);
    
  },
  /**
   * Sets the projects and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of projects.
   * @param {number} payload.count - The total count of projects.
   */
  SET_ALL_PROJECTS(state, payload) {
    state.allProjects.data = payload.items;
    state.allProjects.count = payload.count;
  },
  /**
   * Updates the status of the update project in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the project.
   */
  SET_UPDATE_PROJECT_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an project object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated project object.
   * @return {void}
   */
  SET_UPDATE_PROJECT(state, payload) {
    const index = state.projects.data.findIndex((d) => d.id === payload.id);
    const project = state.projects.data[index];
    state.projects.data[index] = { ...project, ...payload };
  },
  SET_CREATE_PROJECT_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new project to the list of projects in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The project object to be added.
   * @return {void}
   */
  SET_CREATE_PROJECT(state, payload) {
    state.projects.data.push(payload);
  },
  /**
   * Updates the status of the delete project in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the project.
   */
  SET_DELETE_PROJECT_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an project from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the project ID to be deleted.
   * @param {number} payload.id - The ID of the project to be deleted.
   * @return {void}
   */
  SET_DELETE_PROJECT(state, payload) {
    state.projects.data = state.projects.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_PROJECT_BY_ID_STATUS(state, payload) {
    state.projectById.status = payload;
  },
  SET_PROJECT_BY_ID(state, payload) {
    const index = state.projectById.data.findIndex((d) => d.id === payload.id);
    if (index > -1) state.projectById.data.splice(index, 1);
    state.projectById.data.push(payload);
  },
  SET_PROJECT_CHANGED_LOGS_BY_ID_STATUS(state, payload) {
    state.changedLogs.status = payload;
  },
  SET_PROJECT_CHANGED_LOGS_BY_ID(state, payload) {
    const index = state.changedLogs.data.findIndex(
      (d) => d.projectId === payload.projectId
    );
    if (index > -1) state.changedLogs.data.splice(index, 1);
    state.changedLogs.data.unshift(payload);
  },
  SET_PROJECT_PERMISSIONS_BY_ID_STATUS(state, payload) {
    state.projectPermissions.status = payload;
  },
  SET_PROJECT_PERMISSIONS_BY_ID(state, payload) {
    const index = state.projectPermissions.data.findIndex(
      (d) => d.projectId === payload.projectId
    );
    if (index > -1) state.projectPermissions.data.splice(index, 1);
    state.projectPermissions.data.unshift(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of projects based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.paymentMethodId - The ID of the payment method to filter by.
   * @return {Promise<void>}
   */
  async getProjects({ commit }, payload) {
    commit("SET_PROJECT_STATUS", "loading");
    const response = await Requests.Project.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_PROJECTS", {
        items: response.data.items.map((item) => {
          const evaporator = item.batteryInfo.find(
            (battery) => battery.type === "Evaporator"
          );
          const condenser = item.batteryInfo.find(
            (battery) => battery.type === "Condenser"
          );
          return {
            ...item,
            page: payload.query.page || 1,
            evaporatorInfo: evaporator,
            condenserInfo: condenser,
          };
        }),
        count: response.data.count,
      });
    }
    commit("SET_PROJECT_STATUS", response.message === "OK" ? "success" : response.message);
    return response.message;
  },
  /**
   * Creates an project by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the project data.
   * @param {string} payload.paymentMethodId - The ID of the payment method.
   * @param {string} payload.projectRate - The project rate.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createProject({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.Project.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_PROJECT", {
          id: response.data,
          ...payload,
          isActive: true,
          page: 1,
        });
      else state.createStatus = "error";
      return response;
    } catch {
      state.createStatus = "error";
      return { message: "ERROR" };
    }
  },
  /**
   * Updates an project by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the project data to update.
   * @param {string} payload.paymentMethodId - The ID of the payment method.
   * @param {string} payload.projectRate - The project rate.
   * @param {boolean} payload.isActive - Whether the project is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateProject({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.Project.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_PROJECT", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
      return response;
    } catch {
      state.updateStatus = "error";
      return { message: "ERROR" };
    }
  },
  /**
   * Removes an project from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the project data.
   * @param {number} payload.id - The ID of the project to be removed.
   * @returns {Promise<void>} A promise that resolves when the project is successfully removed.
   */
  removeProject({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.Project.Delete({ params: { id } })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
        return response;
      })
      .catch(() => {
        state.deleteStatus = "error";
        return { message: "ERROR" };
      });
  },
  /**
   * Retrieves an project by their ID and updates the project by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the project to retrieve.
   * @return {Promise} A promise that resolves when the project is successfully retrieved and the status is updated.
   */
  getProjectById({ commit, state }, { id, force = false }) {
    // check if project already exists in the state;
    console.log(id, force, "store");

    const project = state.projectById.data.find((project) => project.id == id);
    if (project && !force) return { message: "OK", data: project };
    commit("SET_PROJECT_BY_ID_STATUS", "loading");
    return Requests.Project.GetById({ params: { id } })
      .then((response) => {
        if (response.message === "OK")
          if (response.data) commit("SET_PROJECT_BY_ID", response.data);
        commit("SET_PROJECT_BY_ID_STATUS", "success");
        return response;
      })
      .catch(() => {
        commit("SET_PROJECT_BY_ID_STATUS", "error");
        return { message: "FAIL" };
      });
  },
  getProjectChangedLogsById({ commit, state }, { projectId, force = false }) {
    // check if project already exists in the state;
    console.log(projectId, "projectId");

    if (
      state.changedLogs.data.find(
        (project) => project.projectId === projectId
      ) &&
      !force
    )
      return state.changedLogs.data.find(
        (project) => project.projectId === projectId
      );
    commit("SET_PROJECT_CHANGED_LOGS_BY_ID_STATUS", "loading");
    return Requests.Project.GetProjectLogs({ query: { id: projectId } })
      .then((response) => {
        commit("SET_PROJECT_CHANGED_LOGS_BY_ID", {
          projectId,
          ...response.data,
        });
        commit("SET_PROJECT_CHANGED_LOGS_BY_ID_STATUS", "success");
        return response.data;
      })
      .catch(() => {
        commit("SET_PROJECT_CHANGED_LOGS_BY_ID_STATUS", "error");
        return {};
      });
  },
  getProjectPermissionsById({ commit, state }, { projectId, force = false }) {
    // check if project already exists in the state;

    if (
      state.projectPermissions.data.find(
        (project) => project.projectId === projectId
      ) &&
      !force
    )
      return state.projectPermissions.data.find(
        (project) => project.projectId === projectId
      );
    commit("SET_PROJECT_PERMISSIONS_BY_ID_STATUS", "loading");
    return Requests.ProjectPermissions.GetProjectPermissionUsers({
      query: { projectId: projectId },
    })
      .then((response) => {
        commit("SET_PROJECT_PERMISSIONS_BY_ID", {
          projectId,
          ...response.data,
        });
        commit("SET_PROJECT_PERMISSIONS_BY_ID_STATUS", "success");
        return response.data;
      })
      .catch(() => {
        commit("SET_PROJECT_PERMISSIONS_BY_ID_STATUS", "error");
        return {};
      });
  },
};

export default { state, getters, mutations, actions };
